export enum RequestChannel {
  ONLINE = "ONLINE",
  AGENT = "AGENT",
}
